import axios from 'axios'
import router from '@/router'
import { useToast } from 'vue-toastification'

//const API_DEFAULT_BASE_URL = 'https://my.hidnseek.Fr'
//const API_DEFAULT_BASE_URL = 'http://localhost:3000'
const API_DEFAULT_BASE_URL = 'https://api.localizce.com'
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || API_DEFAULT_BASE_URL

// Configuration de base d'axios
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json; charset=UTF-8'
    },
    //   withCredentials: true
})

// Liste des routes qui ne nécessitent pas d'authentification
const publicRoutes = ['/users/sign_in.json', '/users.json', '/users/password.json']

// Intercepteur pour ajouter le token d'authentification
api.interceptors.request.use(config => {
    const userToken = localStorage.getItem('user_token')
    const userEmail = localStorage.getItem('user_email')
    const isPublicRoute = publicRoutes.some(route => config.url?.includes(route))

    if ((!userToken || !userEmail) && !isPublicRoute) {
        // Nettoyer le localStorage avant la redirection
        localStorage.removeItem('user_token')
        localStorage.removeItem('user_email')
        router.push('/login')
        return Promise.reject('Non authentifié')
    }

    if (userToken && userEmail) {
        // Ajouter les paramètres à l'URL
        const separator = config.url?.includes('?') ? '&' : '?'
        config.url = `${config.url}${separator}user_token=${userToken}&user_email=${userEmail}`
    }

    return config
})

// Intercepteur pour gérer les erreurs d'authentification
api.interceptors.response.use(
    response => response,
    error => {
        const toast = useToast()

        if (error.response) {
            // Erreur avec réponse du serveur
            const status = error.response.status
            const errorMessage = error.response.data?.error || error.response.data?.message || 'Une erreur est survenue'

            switch (status) {
                case 401:
                    const isPublicRoute = publicRoutes.some(route => error.config.url?.includes(route))
                    if (!isPublicRoute) {
                        localStorage.removeItem('user_token')
                        localStorage.removeItem('user_email')
                        router.push('/login')
                    }
                    toast.error('Session expirée. Veuillez vous reconnecter.')
                    break
                case 403:
                    toast.error('Vous n\'avez pas les permissions nécessaires.')
                    break
                case 404:
                    toast.error('La ressource demandée n\'existe pas.')
                    break
                case 422:
                    toast.error('Données invalides. Veuillez vérifier vos informations.')
                    break
                case 429:
                    toast.error('Trop de requêtes. Veuillez réessayer plus tard.')
                    break
                case 500:
                    toast.error('Erreur serveur. Veuillez réessayer plus tard.')
                    break
                default:
                    toast.error(errorMessage)
            }
        } else if (error.request) {
            // Erreur sans réponse du serveur
            toast.error('Impossible de contacter le serveur. Vérifiez votre connexion internet.')
        } else {
            // Erreur lors de la configuration de la requête
            toast.error('Une erreur est survenue lors de la préparation de la requête.')
        }

        return Promise.reject(error)
    }
)

export default api 